'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgArrowDown = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M11.614 2.057a.814.814 0 0 0-.505.396l-.089.167-.01 8.479-.011 8.479-2.729-2.725c-1.828-1.824-2.786-2.753-2.898-2.809-.352-.176-.733-.085-1.073.255-.347.346-.436.711-.26 1.064.127.252 7.337 7.471 7.589 7.597a.832.832 0 0 0 .744 0c.252-.126 7.462-7.345 7.589-7.597.176-.353.087-.718-.26-1.064-.34-.34-.721-.431-1.073-.255-.112.056-1.07.985-2.898 2.809l-2.729 2.725-.011-8.479-.01-8.479-.089-.167a.874.874 0 0 0-.213-.254c-.264-.189-.721-.249-1.064-.142", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgArrowDown);

exports["default"] = ForwardRef;
//# sourceMappingURL=ArrowDown.js.map
